import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15

export default {
    current: () =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.partnersUri.concat('current')).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}